// Display-only evidence. Never writes or derives the PM-owned project Status.
export function signalNumber(value) {
  if (value == null || typeof value === "boolean" || String(value).trim() === "") return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

export function budgetHealth(budget, forecast) {
  const b = signalNumber(budget), f = signalNumber(forecast);
  if (b == null || b <= 0 || f == null || f < 0) {
    return { state: "not_tracked", label: "Not tracked", ratio: null, overage: null };
  }
  const ratio = f / b;
  return {
    state: ratio > 1 ? "over" : ratio >= 0.95 ? "near" : "neutral",
    label: ratio > 1 ? "Over budget" : ratio >= 0.95 ? "Near budget" : "Under budget",
    ratio, overage: ratio > 1 ? f - b : null,
  };
}

export function signalDate(value) {
  if (!value) return null;
  const raw = value instanceof Date ? (Number.isFinite(value.getTime()) ? value.toISOString().slice(0, 10) : "") : String(value);
  const date = /^\d{4}-\d{2}-\d{2}(?:$|T)/.test(raw) ? raw.slice(0, 10) : "";
  const parsed = new Date(`${date}T00:00:00Z`);
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date ? date : null;
}

export function projectLocalToday(timeZone, now = new Date()) {
  if (!timeZone || !Number.isFinite(new Date(now).getTime())) return null;
  try {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date(now));
    const get = type => parts.find(p => p.type === type)?.value;
    return `${get("year")}-${get("month")}-${get("day")}`;
  } catch {
    return null;
  }
}

export function milestoneSignal(milestone, timeZone, now = new Date()) {
  if (!milestone || milestone.status === "complete" || milestone.deletedAt) return { overdue: false, days: null, reason: null };
  const date = signalDate(milestone.dueDate ?? milestone.date);
  if (!date) return { overdue: false, days: null, reason: "Target date unavailable" };
  const today = projectLocalToday(timeZone, now);
  if (!today) return { overdue: false, days: null, reason: "Project time zone unavailable; overdue status unknown" };
  const days = Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${date}T00:00:00Z`)) / 86400000);
  return { overdue: days > 0, days: days > 0 ? days : 0, reason: null };
}

export function selectNextMilestone(items) {
  return (Array.isArray(items) ? items : [])
    .filter(m => m && m.status !== "complete" && !m.deletedAt)
    .sort((a, b) => (signalDate(a.dueDate) || "9999-12-31").localeCompare(signalDate(b.dueDate) || "9999-12-31")
      || String(a.id).localeCompare(String(b.id)))[0] || null;
}

export function positiveProblem(value, problem = false) {
  const n = signalNumber(value);
  return problem && n != null && n > 0;
}
